import { DateTime } from "luxon";

export const formatEventName = (s: string) => {
  return s
    .replace(/^[-_]*(.)/, (_, c) => c.toUpperCase())
    .replace(/[-_]+(.)/g, (_, c) => " " + c.toUpperCase());
};

export const camelCaseToWords = (s: string) => {
  const result = s.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const getAuditStartDate = (startDate: string | null) => {
  return startDate
    ? DateTime.fromFormat(startDate, "dd/MM/yyyy").startOf("day")
    : null;
};
export const getAuditEndDate = (endDate: string | null) => {
  return endDate
    ? DateTime.fromFormat(endDate, "dd/MM/yyyy").endOf("day")
    : null;
};
